import { render, staticRenderFns } from "./TableLoaderSkeleton.vue?vue&type=template&id=19a6ff5a"
import script from "./TableLoaderSkeleton.vue?vue&type=script&lang=js"
export * from "./TableLoaderSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports